
import {extend} from './zviz2/zviz/functions';
import state from './zviz2/zviz/state';

export let styleText = {
    fontFamily: '"RO Sans", Helvetica, Arial, sans-serif',
    // fontSize: '11pt',
    fontSize: (ctrl) => ( (state.get('renderSize') == 'large')? '18px': '15px' ),
    lineHeight: '1.5em',
    color: '#000000',
    fill: '#000000'
};

export let styleH1 = extend({
     fontSize: (ctrl) => (state.get('renderSize') == 'small'? '26px': '32px'),
     lineHeight: (ctrl) => (state.get('renderSize') == 'small'? '1.4em': '2em'),
     color: '#01689b',
     fill: '#01689b',
     fontWeight: 'bold'
}, styleText);

export let styleH2 = extend({
     fontSize: (ctrl) => (state.get('renderSize') == 'small'? '26px': '32px'),
     lineHeight: (ctrl) => (state.get('renderSize') == 'small'? '1.4em': '2em'),
     color: '#01689b',
     fontWeight: 'normal'
}, styleText);

export let styleH3 = extend({
     fontSize: (ctrl) => (state.get('renderSize') == 'small'? '20px': '26px'),
     lineHeight: (ctrl) => (state.get('renderSize') == 'small'? '1.4em': '2em'),
     color: '#01689b',
     fill: '#01689b',
     fontWeight: 'bold'
}, styleText);

export let styleH4 = extend({
     fontSize: (ctrl) => (state.get('renderSize') == 'small'? '16px': '20px'),
     lineHeight: (ctrl) => (state.get('renderSize') == 'small'? '1.4em': '2em'),
     color: '#000000',
     fill: '#000000',
     fontWeight: 'normal'
}, styleText);

export let styleSubtitle = extend({
     fontSize: (ctrl) => (state.get('renderSize') == 'small'? '13px': '15px'),
     lineHeight: '1.5em',
     color: '#515151',
     fill: '#515151',
     fontWeight: 'italic'
}, styleText);

export let styleNumber = extend({
     fontSize: (ctrl) => (state.get('renderSize') == 'small'? '22px': '28px'),
     lineHeight: (ctrl) => (state.get('renderSize') == 'small'? '1em': '1em'),
     color: '#515151',
     fill: '#515151',
     fontWeight: 'bold'
}, styleText);

export let styleNumberSmall = extend({
     fontSize: (ctrl) => (state.get('renderSize') == 'small'? '13px': '15px'),
}, styleNumber);

